import { Ref, ref, inject, provide } from "vue";

interface RuntimeConfig {
  enableLinks: boolean;
  globalEmit?: (name: string, payload: unknown) => void;
}

const defaultConfig: Ref<RuntimeConfig> = ref({
  enableLinks: true
});

export function createRuntimeConfig(initialOptions: RuntimeConfig) {
  return ref(initialOptions);
}
export const runtimeConfigSymbol = Symbol("runtimeConfigSymbol");

export function provideRuntimeConfig(runtimeConfig: Ref<RuntimeConfig>) {
  provide(runtimeConfigSymbol, runtimeConfig);
}

export function injectRuntimeConfig() {
  return inject<Ref<RuntimeConfig>>(runtimeConfigSymbol, defaultConfig);
}
